/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type TicketNotificationV1Dto = {
  /**
   * The unique identifier of the entity.
   */
  readonly id: string;
  /**
   * The date when the entity was created.
   */
  readonly createdAt: string;
  /**
   * The type of event that triggered the notification.
   */
  eventType: TicketNotificationV1Dto.eventType;
  /**
   * The ID of the user who triggered the event.
   */
  triggeredByUserId?: string | null;
  /**
   * The name of the user who triggered the event.
   */
  triggeredByUserName?: string | null;
  /**
   * Additional event data in JSON format.
   */
  eventData?: Record<string, any> | null;
  /**
   * The date when the notification was read.
   */
  readAt?: string | null;
  /**
   * The unique identifier of the ticket.
   */
  ticketId: string;
};
export namespace TicketNotificationV1Dto {
  /**
   * The type of event that triggered the notification.
   */
  export enum eventType {
    BY_USER = 'BY_USER',
    CREATED = 'CREATED',
    UPDATED = 'UPDATED',
    STATUS_CHANGED = 'STATUS_CHANGED',
    DOCUMENT_ADDED = 'DOCUMENT_ADDED',
    EMAIL_ADDED = 'EMAIL_ADDED',
    COMMENT_ADDED = 'COMMENT_ADDED',
    DELETED = 'DELETED',
    BATCH_DELETED = 'BATCH_DELETED',
    PROCESS_TRANSITION = 'PROCESS_TRANSITION',
  }
}
